import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import CellRendererStatus from "@/components/visit-point/list/cell-renderer/CellRendererStatus.vue";
import CellRendererCheckPickup from "@/components/optimization/datarutas/visit-point/cell-renderer/CellRendererCheckPickup.vue";
import CellRendererCheckDelivery from "@/components/optimization/datarutas/visit-point/cell-renderer/CellRendererCheckDelivery.vue";
import CellRenderCustomHeader from "@/components/optimization/cell-renderer/CellRenderCustomHeader.vue";
import moduleMap from "@/store/map/moduleMap.js";

window.numberParser = function numberParser(params) {
	return Number(params.newValue) | 0;
};

export const visitPoinListDatarutas = {
	name: "VisitPoinListDatarutas",
	props: {
		customConfig: {
			type: Object,
			default: () => {
				return {
					rowSelection: "multiple",
					activeCheckbox: false,
					columns: [],
					tableOptions: true,
					showItemsPerPage: true,
					showPopup: false,
					showMaximizeBtn: false,
					showActions: false,
				};
			},
		},
		relatedIds: {
			type: Array,
			default: () => [],
		},
		status_id: {
			type: Array,
			default: () => [],
		},
		maximize: {
			type: Boolean,
			default: false,
		},
		circleList: {
			type: Array,
			default: () => [],
		},
		polygonList: {
			type: Array,
			default: () => [],
		},
		typeSelected: {
			type: String,
			default: "",
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererStatus,
		CellRendererCheckPickup,
		CellRendererCheckDelivery,
		CellRenderCustomHeader,
	},
	data() {
		return {
			roleFilter: {label: "All", value: "all"},
			statusFilter: {label: "All", value: "all"},
			isVerifiedFilter: {label: "All", value: "all"},
			isModeSelected: false,
			showSelected: false,
			searchQuery: [],
			arrayVisitPoint: [],
			additionalField: null,
			additionalOptions: [],
			isMounted: false,
			showBtnDeleteShape: false,
			tooltipShowDelay: null,
			currentPageLocal: 1,
			quantityElementPage: 3,
			searchField: "Identification",
			gridApi: null,
			gridOptions: {},
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
			},
			components: {
				CellRendererStatus,
				CellRendererCheckPickup,
				CellRendererCheckDelivery,
				CellRenderCustomHeader,
			},
		};
	},
	watch: {
		searchField(val) {
			if (val !== "AdditionalFields") {
				this.additionalField = null;
			}
		},
		roleFilter(obj) {
			this.setColumnFilter("typology_name", obj.value);
		},
		statusFilter(obj) {
			this.setColumnFilter("status_name", obj.value);
		},
		isVerifiedFilter(obj) {
			let val = "";
			if (obj.value === "all") {
				val = "all";
			} else if (obj.value === "yes") {
				val = "true";
			} else {
				val = "false";
			}
			this.setColumnFilter("is_verified", val);
		},
		currentPageLocal(page) {
			this.getVisitPoint(page);
		},
		quantityElementPage() {
			this.getVisitPoint(1);
		},
	},
	computed: {
		isSidebarActiveLocal: {
			get() {
				return this.isSidebarActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closeSidebar");
				}
			},
		},
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		columnDefs() {
			let columns = [
				{
					headerComponentFramework: "CellRenderCustomHeader",
					headerComponentParams: {
						displayName: this.$t("PICKUP"),
						isChecked: false,
						onCheckboxChange: (isChecked) => {
							this.selectOrDeselectAll("pickup", isChecked);
						},
					},
					field: "isPickup",
					width: 112,
					headerTooltip: this.$t("PICKUP"),
					cellRendererFramework: "CellRendererCheckPickup",
					sortable: false,
					pinned: "left",
					cellStyle: {textAlign: "center"},
					headerName: this.$t("PICKUP"),
				},
				{
					headerComponentFramework: "CellRenderCustomHeader",
					headerComponentParams: {
						displayName: this.$t("DELIVERY"),
						isChecked: false,
						onCheckboxChange: (isChecked) => {
							this.selectOrDeselectAll("delivery", isChecked);
						},
					},
					field: "isDelivery",
					width: 110,
					headerTooltip: this.$t("DELIVERY"),
					cellRendererFramework: "CellRendererCheckDelivery",
					sortable: false,
					pinned: "left",
					cellStyle: {textAlign: "center"},
					headerName: this.$t("DELIVERY"),
				},
				{
					headerName: this.$t("Routing.Table.Identification"),
					field: "identification",
					width: 220,
				},
				{
					headerName: this.$t("Name"),
					field: "name",
					width: 180,
				},
				{
					headerName: this.$t("Address"),
					field: "address",
					width: 200,
				},
				{
					headerName: this.$t("Divipola.City"),
					field: "city",
					width: 200,
				},
				{
					headerName: this.$t("TypeConfig.Form.Status"),
					field: "status_name",
					width: 150,
					cellRendererFramework: "CellRendererStatus",
				},
			];
			const showColumns =
				this.customConfig.columns !== undefined && this.customConfig.columns.length > 0
					? this.customConfig.columns
					: [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		searchSelected() {
			return this.$t(`ResourceModule.Table.${this.searchField}`);
		},
		usersData() {
			return this.$store.state.moduleVisitPoint.visitPointsDatarutas === undefined ||
				this.$store.state.moduleVisitPoint.visitPointsDatarutas === "" ||
				this.$store.state.moduleVisitPoint.visitPointsDatarutas === null
				? []
				: this.$store.state.moduleVisitPoint.visitPointsDatarutas;
		},
		getCheckedVisitPointsPickup() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoitsPickupDatarutas === undefined ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsPickupDatarutas === "" ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsPickupDatarutas === null
				? []
				: this.$store.state.moduleVisitPoint.checkedVisitPoitsPickupDatarutas;
		},
		getCheckedVisitPointsDelivery() {
			return this.$store.state.moduleVisitPoint.checkedVisitPoitsDeliveryDatarutas === undefined ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsDeliveryDatarutas === "" ||
				this.$store.state.moduleVisitPoint.checkedVisitPoitsDeliveryDatarutas === null
				? []
				: this.$store.state.moduleVisitPoint.checkedVisitPoitsDeliveryDatarutas;
		},
		totalVisitPointChecked() {
			let totalChecked =
				this.getCheckedVisitPointsPickup && this.getCheckedVisitPointsPickup.length > 0
					? this.getCheckedVisitPointsPickup.length
					: 0;
			return totalChecked;
		},
		totalVisitPointCheckedDelivery() {
			let totalChecked =
				this.getCheckedVisitPointsDelivery && this.getCheckedVisitPointsDelivery.length > 0
					? this.getCheckedVisitPointsDelivery.length
					: 0;
			return totalChecked;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
		visitPointsMarkersDatarutas() {
			return this.$store.state.moduleMap.visitPointsMarkersDatarutas === undefined ||
				this.$store.state.moduleMap.visitPointsMarkersDatarutas === "" ||
				this.$store.state.moduleMap.visitPointsMarkersDatarutas === null
				? []
				: this.$store.state.moduleMap.visitPointsMarkersDatarutas;
		},
	},
	methods: {
		selectOrDeselectAll(field, isChecked) {
			const itemsToAdd = [];
			this.gridApi.forEachNode((node) => {
				this.updateNodeAndCollectItems(node, field, isChecked, itemsToAdd);
			});
			this.updateStore(field, isChecked, itemsToAdd);
			this.gridApi.refreshView();
		},
		updateNodeAndCollectItems(node, field, isChecked, itemsToAdd) {
			const property = field === "pickup" ? "isPickup" : "isDelivery";
			node.data[property] = isChecked;
			if (isChecked) {
				itemsToAdd.push(node.data);
			}
		},
		updateStore(field, isChecked, itemsToAdd) {
			const mutationPrefix = field === "pickup" ? "PICKUP" : "DELIVERY";
			if (isChecked) {
				this.$store.commit(`moduleVisitPoint/SET_VISIT_POINT_CHECKED_${mutationPrefix}`, itemsToAdd);
			} else {
				this.$store.commit(`moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED_${mutationPrefix}`);
			}
		},
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		async getVisitPoint(page) {
			this.onBtShowLoading();
			const payload = {
				page,
				sort: "desc",
				order_by: ["id"],
			};
			await this.$store
				.dispatch("moduleVisitPoint/findVisitPointPaginatedDatarutas", payload)
				.then((res) => {
					this.$emit("getVisitPointsInMapDatarutasEmit", res.records);
					Object.assign(this.pagination, res.pagination);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		searchVisitPoint() {
			const searchQueryList = this.searchQuery.map(({value}) => value);
			const dataPage = {
				identification: this.searchField === "Identification" ? searchQueryList : [],
				name: this.searchField === "Name" ? searchQueryList : [],
				address: this.searchField === "Address" ? searchQueryList : [],
				city: this.searchField === "City" ? searchQueryList : [],
				status_name: ["ACTIVE"],
				order_by: ["id"],
				sort: "desc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("moduleVisitPoint/findVisitPointPaginatedDatarutas", dataPage)
				.then((res) => {
					this.$emit("getVisitPointsInMapDatarutasEmit", res.records);
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
						this.setDefaultSelectedRow();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		async onGridReady() {},
		rowSelected(event) {},
		setDefaultSelectedRow() {
			const relatedIdsPickup = this.getCheckedVisitPointsPickup;
			if (relatedIdsPickup.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIdsPickup.some((r) => r.id === node.data.id && r.isPickup === true);
					node.setDataValue("isPickup", valid);
				});
			}
			const relatedIdsDelivery = this.getCheckedVisitPointsDelivery;
			if (relatedIdsDelivery.length > 0) {
				this.gridApi.forEachNode((node) => {
					const valid = relatedIdsDelivery.some((r) => r.id === node.data.id && r.isDelivery === true);
					node.setDataValue("isDelivery", valid);
				});
			}
		},
		refreshVisitPoint() {
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.isModeSelected = false;
			this.$emit("getModeSelectedEmit", this.isModeSelected);
			this.getVisitPoint(1);
			if (this.circleList.length > 0) {
				for (let circle of this.circleList) {
					if (circle.typeService === "all") {
						circle.setMap(null);
					}
				}
			}
			if (this.polygonList.length > 0) {
				for (let polygon of this.polygonList) {
					if (polygon.typeService === "all") {
						polygon.setMap(null);
					}
				}
			}
			this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED_PICKUP_DATARUTAS");
			this.$store.commit("moduleVisitPoint/REMOVE_ALL_VISIT_POINT_CHECKED_DELIVERY_DATARUTAS");
		},
		setSearchField(val) {
			this.searchField = val;
		},
		selectedVisitsPoint(initValue) {
			this.showSelected = true;
			if (
				this.getCheckedVisitPointsPickup.length >= initValue ||
				this.getCheckedVisitPointsDelivery.length >= initValue
			) {
				const filterPickup = this.getCheckedVisitPointsPickup.filter(
					(data) => data.isPickup === true && data.isDelivery === false
				);
				const filterDelivery = this.getCheckedVisitPointsDelivery.filter(
					(data) => data.isDelivery === true && data.isPickup === false
				);
				const filterAll = this.getCheckedVisitPointsPickup.filter(
					(data) => data.isPickup === true && data.isDelivery === true
				);
				this.$emit("showSelectedVisitsPointEmit", [...filterPickup, ...filterDelivery, ...filterAll]);
				this.isModeSelected = true;
				this.$emit("showSelectedVisitsPointEmit", [...filterPickup, ...filterDelivery, ...filterAll]);
				Anuket.fitBoundsLatLngArray(
					[...filterPickup, ...filterDelivery, ...filterAll].map((data) => {
						if ((data.cy != null || data.cy != 0) && (data.cx != null || data.cx != 0))
							return {lat: data.cy, lng: data.cx};
					})
				);
			}
			this.$emit("getModeSelectedEmit", this.isModeSelected);
		},
		removeChips() {
			this.showSelected = false;
			this.isModeSelected = false;
			this.$emit("getModeSelectedEmit", this.isModeSelected);
			if (this.getCheckedVisitPointsPickup.length > 0 || this.getCheckedVisitPointsDelivery.length > 0) {
				this.gridApi.setRowData(this.usersData);
				this.setDefaultSelectedRow();
				this.$emit("getVisitPointsInMapDatarutasEmit", this.usersData);
			}
		},
		clearSearch() {
			this.searchQuery = [];
			this.currentPageLocal = 1;
			this.isModeSelected = false;
			this.searchVisitPoint();
		},
		selectRowsShape(visitPointArray, is_pickup, is_delivery) {
			return new Promise((resolve, reject) => {
				try {
					if (visitPointArray && visitPointArray.length > 0) {
						this.gridApi.forEachNode((node) => {
							this.processNode(node, visitPointArray, is_pickup, is_delivery);
						});
					}
					this.$vs.loading.close();
					resolve(true);
				} catch (e) {
					this.$vs.loading.close();
					reject(e);
				}
			});
		},
		processNode(node, visitPointArray, is_pickup, is_delivery) {
			for (const visitPoint of visitPointArray) {
				if (visitPoint.id === node.data.id && !node.isSelected()) {
					this.updateNodeValues(node, is_pickup, is_delivery);
					break; // Optimization: Exit loop after finding a match
				}
			}
		},
		updateNodeValues(node, is_pickup, is_delivery) {
			if (is_pickup && is_delivery) {
				this.setPickupDelivery(node);
			} else if (is_pickup) {
				this.setPickup(node);
			} else if (is_delivery) {
				this.setDelivery(node);
			}
		},
		setPickupDelivery(node) {
			node.setDataValue("isPickup", true);
			node.setDataValue("isDelivery", true);
			this.$store.commit("moduleVisitPoint/ADD_VISIT_POINT_CHECKED_PICKUP_DATARUTAS", node.data);
			this.$store.commit("moduleVisitPoint/ADD_VISIT_POINT_CHECKED_DELIVERY_DATARUTAS", node.data);
		},
		setPickup(node) {
			node.setDataValue("isPickup", true);
			this.$store.commit("moduleVisitPoint/ADD_VISIT_POINT_CHECKED_PICKUP_DATARUTAS", node.data);
		},
		setDelivery(node) {
			node.setDataValue("isDelivery", true);
			this.$store.commit("moduleVisitPoint/ADD_VISIT_POINT_CHECKED_DELIVERY_DATARUTAS", node.data);
		},
		getMarkersInsideCircle(circle) {
			const center = circle.getCenter();
			const radius = circle.getRadius();
			const selectedPoints = [];
			this.$vs.loading();
			return new Promise((resolve, reject) => {
				try {
					this.visitPointsMarkersDatarutas.features.forEach((feature) => {
						const point = new google.maps.LatLng(
							feature.geometry.coordinates[1],
							feature.geometry.coordinates[0]
						);
						if (google.maps.geometry.spherical.computeDistanceBetween(center, point) <= radius) {
							selectedPoints.push(feature);
						}
					});
					circle.arrayVisitPoint = selectedPoints.map((item) => item.properties);
					resolve(true);
				} catch (e) {
					reject(e);
				}
			});
		},
		getMarkersInsidePolygon(polygon) {
			this.$vs.loading();
			return new Promise((resolve, reject) => {
				try {
					const selectedPoints = this.visitPointsMarkersDatarutas.features.filter((feature) => {
						const point = new google.maps.LatLng(
							feature.geometry.coordinates[1],
							feature.geometry.coordinates[0]
						);
						return google.maps.geometry.poly.containsLocation(point, polygon);
					});
					polygon.arrayVisitPoint = selectedPoints.map((item) => item.properties);
					resolve(true);
				} catch (e) {
					reject(e);
				}
			});
		},
		async validateMarkerSelectionCircle(circle, is_pickup, is_delivery) {
			if (is_pickup && !is_delivery) {
				circle.setOptions({strokeColor: "#420d91", fillColor: "#420d91"});
				circle.typeService = "pickup";
			} else if (is_delivery && !is_pickup) {
				circle.setOptions({strokeColor: "#ff9f43", fillColor: "#ff9f43"});
				circle.typeService = "delivery";
			} else {
				circle.typeService = "all";
			}
			await this.getMarkersInsideCircle(circle);
			this.selectRowsShape(circle.arrayVisitPoint, is_pickup, is_delivery).then((res) => {
				if (res) this.$vs.loading.close();
			});
		},
		async validateMarkerSelectionPolygon(polygon, is_pickup, is_delivery) {
			if (is_pickup && !is_delivery) {
				polygon.setOptions({strokeColor: "#420d91", fillColor: "#420d91"});
				polygon.typeService = "pickup";
			} else if (is_delivery && !is_pickup) {
				polygon.setOptions({strokeColor: "#ff9f43", fillColor: "#ff9f43"});
				polygon.typeService = "delivery";
			} else {
				polygon.typeService = "all";
			}
			await this.getMarkersInsidePolygon(polygon);
			this.selectRowsShape(polygon.arrayVisitPoint, is_pickup, is_delivery).then((res) => {
				if (res) this.$vs.loading.close();
			});
		},
		onPaste(event) {
			let clipped = event.clipboardData.getData("text/plain").split(",");
			if (clipped.length > 0) {
				clipped.forEach((item) => {
					this.searchQuery.push({
						key: "",
						value: item,
					});
				});
				this.searchVisitPoint();
				event.target.blur();
			}
		},
		clearInput() {
			if (this.searchQuery.length <= 0) this.searchVisitPoint();
		},
		getAdditionalInfo(data) {
			this.additionalOptions = data.map((info) => {
				return {label: info.label, value: info.value};
			});
		},
		handleMaximizeEmit() {
			this.$emit("handleMaximize");
		},
	},
	mounted() {
		const dataInputPickup = document.querySelector("#searchdataPickup");
		dataInputPickup.addEventListener("paste", this.onPaste, false);
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		this.gridApi = this.gridOptions.api;
		this.isMounted = true;
		this.$emit("gridApiDatarutasEmit", this.gridApi);
	},
	created() {
		this.tooltipShowDelay = 500;
		if (!moduleMap.isRegistered) {
			this.$store.registerModule("moduleMap", moduleMap);
			moduleMap.isRegistered = true;
		}
	},
};
